import { render, staticRenderFns } from "./exam-paper-edit.vue?vue&type=template&id=d0fcf056&scoped=true&"
import script from "./exam-paper-edit.vue?vue&type=script&lang=ts&"
export * from "./exam-paper-edit.vue?vue&type=script&lang=ts&"
import style0 from "./exam-paper-edit.vue?vue&type=style&index=0&id=d0fcf056&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fcf056",
  null
  
)

export default component.exports